<template>
  <div class="elevation-6 initial-card pt-10">
    <v-container>
        <div class="d-flex justify-center flex-column mt-6">
                <img :src="require('@/assets/icons/key.svg')" alt="logo">
                <span class="headline grey-darken--text text--darken-3 text-center pt-2 font-weight-bold">Redefina sua senha</span>
            </div>
        <div class="px-12">
            <v-form
                ref="form"
                v-model="valid"
                class="d-flex flex-column align-center justify-center"
                >
                <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    name="input-10-1"
                    label="Nova senha"
                    hint=""
                    counter
                    @click:append="show = !show"
                    class="fluid"
                ></v-text-field>

                <v-text-field
                    v-model="passwordConfirm"
                    :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[(password === passwordConfirm) || 'Não confere com a senha acima.']"
                    :type="showConfirm ? 'text' : 'password'"
                    name="input-10-1"
                    label="Confirme sua nova senha"
                    hint=""
                    counter
                    @click:append="showConfirm = !showConfirm"
                    class="fluid"
                ></v-text-field>
                <div class="fluid d-flex justify-center">
                    <v-btn
                        :disabled="!valid"
                        color="#1c579a"
                        class="white--text button-primary elevation-2 mt-6"
                        @click="send()"
                    >
                        Redefinir Senha
                    </v-btn>
                </div>

                <router-link to="/login" class="light-blue--text text--darken-4 body-2 decoration-none mt-8">Voltar para Login</router-link>
            </v-form>
        </div>
        <v-snackbar
            v-model="notification.active"
            :top="true"
            :color="notification.type"
            @input="redirectLogin"
        >
            {{ notification.description }}
            <v-btn
                color="white"
                text
                @click="notification.active = false"
            >
                {{ notification.closeText }}
            </v-btn>
        </v-snackbar>
    </v-container>
    <v-snackbar
      v-model="snackbar.active"
      :top="true"
      :color="snackbar.type"
    >
      {{ snackbar.text }}
      <v-btn
        color="white"
        text
        @click="redirectLogin"
      >
        {{ snackbar.closeText }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
    data: () => ({
      notification: {
        active: false,
        description: '',
        type: '',
        closeText: ''
      },
      snackbar: {
        active: false,
        text: 'Senha redefinida com sucesso!',
        type: 'success',
        closeText: 'Ok'
      },
      valid: true,
      show: false,
      password: '',
      rules: {
        required: value => !!value || 'Este campo é obrigatório.',
        min: v => v.length >= 8 || 'Sua senha precisa ter pelo menos 8 caracteres',
      },
      showConfirm: false,
      passwordConfirm: ''
    }),

    methods: {
      send () {
        if ( this.$refs.form.validate() ) {
            this.$http.put('/reset_password', {
                password: this.password
            }, {
              headers: {
                Authorization: 'Bearer ' + this.$route.params.token
              }
            }).then( () => {
                this.snackbar.active = true;
            } ).catch( err => {
                this.showError(err);
            } );
        }
        return false
      },
      showError(error) {
        this.notification = {
          active: true,
          description: error,
          type: 'error',
          closeText: 'Fechar'
        }
      },
      redirectLogin() {
        this.$router.push('/login');
      }
    },
}
</script>

<style scoped>
    
</style>